import React, { useContext, useState } from 'react'
import Popover from '@mui/material/Popover';
import MenuList from '@mui/material/MenuList';
import MenuItem from '@mui/material/MenuItem';

import Button from 'components/UI/Button'
import { useIntlHelper } from 'hooks'
import { plusBlue, library, externalLink, addCustomWidget, arrowDown } from 'assets/icons'
import { dashboardMenu } from '../../../../../../utils/utilsDashboard'

import DialogNewParentMenuName from './DialogNewParentMenuName';
import Context from '../../../Context'


import './styles.scss'

type ParentMenu = {
  id: number;
  label: string;
  new: boolean;
};

type AddButtonProps = {
  style: {
    [key: string]: any
  },
  menuItems: {
    id: number;
    label: string;
    new: boolean;
  }[];
  setParentMenuName: React.Dispatch<React.SetStateAction<ParentMenu | string | null>>;
  setNewParentName: (v: string) => void;
  setStep: (v: number) => void;
}

const AddButton: React.FC<AddButtonProps> = ({ style = {}, menuItems = [], setParentMenuName, setNewParentName, setStep}) => {
  const [anchorElSelectParentMenu, setAnchorElSelectParentMenu] = useState(null);
  const [isDialogOpen, setIsDialogOpen] = useState(false);
  

  const { getIntlMessage } = useIntlHelper()

  const handleClickSelectParentMenu = (event: any) => {
    setAnchorElSelectParentMenu(event.currentTarget);
  };

  const handleCloseSelectParentMenu = () => {
    setAnchorElSelectParentMenu(null);
  };

  const openManageNewParentMenuNameModal = () => {
    setIsDialogOpen(true);
  }

  const closeDialog = () => {
    setIsDialogOpen(false);
  };
  

  const selectParentMenuItem = (item:any) => {
    setParentMenuName(item)
    setNewParentName(item)
    setStep(1)
  }

  const createParentMenuView = () => {
    return (
      <div style={style} className='select-parent-menu-widget-wrapper'>
        <Button
          id="add-widget-button"
          variant='text'
          className='select_parent_menu_widget_btn'
          aria-haspopup="true"
          onClick={openManageNewParentMenuNameModal}
        >
          <img
            src={plusBlue}
            alt="add new widget"
          />
          <h3 style={{paddingLeft:'10px'}}>Create a parent menu</h3>
        </Button>

        <DialogNewParentMenuName
          open={isDialogOpen}
          onClose={closeDialog}
          setParentMenuName={setParentMenuName}
          setNewParentName={setNewParentName}
          setStep={setStep}
          isEditMode={false}
          getIntlMessage={getIntlMessage}
        />
        
      </div>
    );
  }

  const selectParentMenuView = () => {
    return (
      <div style={style} className='select-parent-menu-widget-wrapper'>
        <Button
          id="add-widget-button"
          aria-describedby={idParentMenu}
          variant='text'
          className='select_parent_menu_widget_btn'
          aria-controls={openSelectParentMenu ? 'options-menu' : undefined}
          aria-haspopup="true"
          aria-expanded={openSelectParentMenu ? 'true' : undefined}
          onClick={handleClickSelectParentMenu}
        >
          <h3 className='select_parent_menu_widget_btn_text'>{getIntlMessage('create_or_select_a_parent_menu')}</h3>
          <img
            src={arrowDown}
            alt="add new widget"
          />
        </Button>
  
        <Popover
          id={idParentMenu}
          open={openSelectParentMenu}
          anchorEl={anchorElSelectParentMenu}
          onClose={handleCloseSelectParentMenu}
          anchorOrigin={{
            vertical: 'bottom',
            horizontal: 'center',
          }}
          transformOrigin={{
            vertical: 'top',
            horizontal: 'center',
          }}
        >
          <MenuList className="options-menu">
            {dashboardMenu.map((item, index) => 
                <MenuItem key={index} onClick={() => selectParentMenuItem(item)}>
                  {item}
                </MenuItem>
              )
            }
          </MenuList>
        </Popover>
      </div>
    );
  }

  const openSelectParentMenu = Boolean(anchorElSelectParentMenu);
  const idParentMenu = openSelectParentMenu ? 'simple-popover' : undefined;

  const { isEditMode } = useContext(Context)
  if (!isEditMode) {
    return <></>
  }

  return(<>
    {selectParentMenuView()}
  </>);
}

export default AddButton